module.exports = __webpack_public_path__ + "img/TRISTE.0ff14074.png";